import { render } from "./SButton.vue?vue&type=template&id=c6cf4064&ts=true"
import script from "./SButton.ts?vue&type=script&lang=ts"
export * from "./SButton.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__